import request from '@/utils/request'

// 获取校区列表
export function getCampuses(params = {}) {
  return request({
    url: '/campuses',
    method: 'get',
    params
  })
}

function buildCampusPayload(data) {
  const payload = {
    name: data.name,
    address: data.address
  }
  const lat = data.latitude
  const lng = data.longitude
  const hasLat = lat !== '' && lat !== undefined && lat !== null
  const hasLng = lng !== '' && lng !== undefined && lng !== null
  if (hasLat && hasLng) {
    payload.latitude = Number(lat)
    payload.longitude = Number(lng)
  }
  if (data.geofenceRadiusMeters !== '' && data.geofenceRadiusMeters !== undefined && data.geofenceRadiusMeters !== null) {
    payload.geofenceRadiusMeters = Number(data.geofenceRadiusMeters)
  }
  if (data.status) {
    payload.status = data.status
  }
  return payload
}

// 创建校区
export function createCampus(data) {
  return request({
    url: '/campuses',
    method: 'post',
    data: buildCampusPayload(data)
  })
}

// 更新校区
export function updateCampus(id, data) {
  return request({
    url: `/campuses/${id}`,
    method: 'patch',
    data: buildCampusPayload({ ...data, status: data.status || 'active' })
  })
}

// 删除校区
export function deleteCampus(id) {
  return request({
    url: `/campuses/${id}`,
    method: 'delete'
  })
}

// 获取教室列表
export function getClassrooms(campusId) {
  return request({
    url: '/classrooms',
    method: 'get',
    params: { campus: campusId }
  })
}

// 创建教室
export function createClassroom(data) {
  return request({
    url: '/classrooms',
    method: 'post',
    data: {
      name: data.name,
      campus: data.campusId,
      capacity: data.capacity,
      notes: data.notes
    }
  })
}

// 更新教室
export function updateClassroom(id, data) {
  return request({
    url: `/classrooms/${id}`,
    method: 'patch',
    data: {
      name: data.name,
      capacity: data.capacity,
      notes: data.notes,
      status: 'active'
    }
  })
}

// 删除教室
export function deleteClassroom(id) {
  return request({
    url: `/classrooms/${id}`,
    method: 'delete'
  })
} 